declare global {
  interface Window { onYouTubeIframeAPIReady: any }
}
declare const YT: any;

window.onYouTubeIframeAPIReady = () => {
  for (const elModal of document.querySelectorAll("dialog.modal--embed-video")) {
    // create YouTube API instance
    const elYtVideo = elModal.querySelector("iframe[src*=youtube]");
    if (!elYtVideo) {
      continue;
    }

    // identify the URL used in the <iframe>'s src attribute
    let url;
    try {
      url = new URL(elYtVideo.getAttribute("src") ?? "");
    } catch (error) {
      continue; // couldn't identify valid URL in iframe src property
    }

    // if URL doesn't already contain enablejsapi=1, add it
    if (!(url.searchParams.has("enablejsapi") && url.searchParams.get("enablejsapi") === "1")) {
      url.searchParams.set("enablejsapi", "1");
      elYtVideo.setAttribute("src", url.href);
    }

    // pause the video playback when the dialog closes
    const ytPlayer = new YT.Player(elYtVideo);
    elModal.addEventListener("close", () => {
      ytPlayer.pauseVideo();
    });
  }
};
